import * as React from 'react';
import Menu from '@mui/material/Menu';
import { IconButton, List, ListItem, ListItemText } from '@mui/material';

import { info } from '../../../db/dbNotacion'
import InfoIcon from '@mui/icons-material/Info';
import { useEffect, useState } from 'react';
import Latex from 'react-latex-next';

export default function MenuBasico(props: any) {

  const { tipo } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const [help, setHelp] = useState({titulo: '', ejemplos: [{id: 0, ejemplo: ''}]})

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (tipo !== '') {
      const help = info.filter(item => item.tipo === tipo)
      setHelp({ titulo: help[0].titulo, ejemplos: help[0].ejemplos })
    }
  }, [tipo])


  return (
    <div>
      <IconButton
        sx={{ margin: 1 }}
        edge="start"
        color="info"
        onClick={handleClick}
        aria-label="close"
        size='small'
      >
        <InfoIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{ color: 'red' }}
      >
        <List sx={{ width: '100%', minWidth: 250, maxWidth: 400, bgcolor: 'background.paper', px: 2 }} disablePadding>
          <ListItem disablePadding>
            <ListItemText primary={<Latex>{`<b>${help.titulo}</b>`}</Latex>} />
          </ListItem>
          {
            help.ejemplos.map(item =>  {
              const {id, ejemplo} = item;

              return (
                <ListItem key={id} disablePadding>
                  <ListItemText primary={
                    <Latex>{`<i class="fa fa-circle" aria-hidden="true" style="font-size:0.5em; margin-right: 7px"></i> ${ejemplo}`}</Latex>} 
                  />
                </ListItem>
              )
            })
          }
        </List>
      </Menu>
    </div>
  );
}
